import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";
import clsx from "clsx";

import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SettingsIcon from "@material-ui/icons/Settings";

import AdminIcon from "../../../../../Assets/Logo/AdminIcon.svg";
import { useStyles } from "./AdminBar.css";
import MobileDrawer from "../MobileDrawer/MobileDrawer";
import { connect } from "react-redux";
import { adminLogout } from "../../../../../Redux/Actions/actions";
import CustomDialogBox from "../../../../CustomDialogBox/CustomDialogBox";
import { withRouter } from "react-router";

class AdminBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      mobileOpen: false,
    };
  }

  handleToggleDrawer = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen,
    });
  };

  handleDialogOpen = () => {
    this.setState({
      dialogOpen: true,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleLogout = async () => {
    this.props.adminLogout();
    this.handleDialogClose();
  };

  render() {
    const { classes, open, schoolDetails } = this.props;
    return (
      <div>
        <div className={classes.sectionMobile}>
          <AppBar>
            <Toolbar position="fixed" className={classes.toolbar}>
              <div style={{ flexGrow: 1 }}>
                <IconButton onClick={this.handleToggleDrawer}>
                  <MenuIcon />
                </IconButton>
              </div>
              <div style={{ color: "#181818", marginRight: 10 }}>
                <b>Role: </b>
                <Chip
                  icon={
                    <img
                      src={AdminIcon}
                      alt={this.props.role}
                      style={{ width: 20, height: 20 }}
                    />
                  }
                  label={this.props.role}
                />
              </div>
              <Tooltip
                arrow
                title={<div style={{ fontSize: 12 }}>Setting</div>}
                className={classes.tooltip}
                onClick={() =>
                  this.props.history.push(`/administration/settings`)
                }
              >
                <SettingsIcon
                  style={{
                    width: 30,
                    height: 30,
                    color: "#181818",
                    marginRight: 10,
                  }}
                />
              </Tooltip>
              <Tooltip
                arrow
                title={<div style={{ fontSize: 12 }}>Logout</div>}
                className={classes.tooltip}
                onClick={this.handleDialogOpen}
              >
                <ExitToAppIcon
                  style={{
                    width: 30,
                    height: 30,
                    color: "#181818",
                    marginRight: 10,
                  }}
                />
              </Tooltip>
            </Toolbar>
          </AppBar>
          {this.state.mobileOpen === true && (
            <MobileDrawer
              role={this.props.role}
              schoolDetails={schoolDetails}
              mobileOpen={this.state.mobileOpen}
              handleToggleDrawer={this.handleToggleDrawer}
            />
          )}
        </div>
        <div className={classes.sectionDesktop}>
          <AppBar
            position="fixed"
            elevation={0}
            className={clsx(classes.appBar, {
              [classes.appBarShift]: open,
            })}
          >
            <Toolbar
              className={classes.toolbar}
              style={{ paddingLeft: open === false && 0 }}
            >
              <IconButton
                disableRipple
                onClick={this.props.handleDrawerOpen}
                edge="start"
                className={clsx(classes.drawerMenuButton, {
                  [classes.hide]: open,
                })}
              >
                <MenuIcon style={{ width: 25, height: 25 }} />
              </IconButton>
              <div
                style={{ flexGrow: 1, color: "#181818", fontWeight: "bold" }}
              >
                {schoolDetails._id ? (
                  <div>
                    {schoolDetails.schoolName} ({schoolDetails.shortName})
                  </div>
                ) : (
                  "School Mangement System"
                )}
              </div>
              <div style={{ color: "#181818", marginRight: 10 }}>
                <b>Role: </b>
                <Chip
                  icon={
                    <img
                      src={AdminIcon}
                      alt={this.props.role}
                      style={{ width: 20, height: 20 }}
                    />
                  }
                  label={<b style={{ color: "#eee" }}>{this.props.role}</b>}
                  style={{ backgroundColor: "#8e8e8e" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Tooltip
                  arrow
                  title={<div style={{ fontSize: 12 }}>Setting</div>}
                  className={classes.tooltip}
                  onClick={() =>
                    this.props.history.push(`/administration/settings`)
                  }
                >
                  <SettingsIcon
                    style={{
                      width: 30,
                      height: 30,
                      color: "#181818",
                      marginRight: 10,
                    }}
                  />
                </Tooltip>
                <Tooltip
                  arrow
                  title={<div style={{ fontSize: 12 }}>Logout</div>}
                  className={classes.tooltip}
                  onClick={this.handleDialogOpen}
                >
                  <ExitToAppIcon
                    style={{
                      width: 30,
                      height: 30,
                      color: "#181818",
                      marginRight: 10,
                    }}
                  />
                </Tooltip>
              </div>
              <CustomDialogBox
                question="Are you sure you want to logout?"
                description="Click logout button to logout from the system"
                buttonLabel="Logout"
                open={this.state.dialogOpen}
                handleClose={this.handleDialogClose}
                handleDelete={this.handleLogout}
              />
            </Toolbar>
          </AppBar>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogout: () => {
      dispatch(adminLogout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AdminBar)));
